
import { toast } from '@/hooks/use-toast';
import { RoadmapTemplate, PromptField } from '@/types/roadmap';

// Interface to handle both old Field (with tag) and new PromptField (with type) formats 
export interface CompatiblePromptField {
  id: string;
  label: string;
  placeholder?: string;
  example?: string; // Added: HTML content for examples
  type?: string; // Changed from union type to string
  tag?: string; // Old property from database
  value?: string; // From PromptField
  options?: string[]; // From PromptField
}

// Helper function to generate UUID for new items
export const generateUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
};

export const handleError = (error: unknown, message: string) => {
  console.error(message, error);
  toast({
    title: "Error",
    description: message,
    variant: "destructive"
  });
  throw error;
};
